export default __webpack_public_path__ + "static/media/akar-icons_linkedin-fill.481f7062.svg";